export default "__VITE_ASSET__DKdxsZoW__"